import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Paper,
    Divider,
    Button
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";
import { getUserPriority } from "../../../services/authService";
import { PROFILE_TYPE } from "../../../helper/globalConstant";


const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
};


function OrderCreateStep3Confirm(props: any) {

    const navigate = useNavigate();
    const [userPriority, setUserPriority] = useState<number | undefined>(getUserPriority());

    useEffect(() => {
        const priority = getUserPriority();
        setUserPriority(priority);
    }, []);


    return (
        <>
            <Paper
                elevation={3}
                sx={{
                    padding: '0',
                    background: "#03171F",
                    color: '#fff',
                    boxShadow: 'none',
                }}
            >
                <Grid container spacing={2}>
                    {props?.orderRef}
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="h6"
                            sx={{
                                fontSize: '16px',
                                color: '#B4B7B8',
                                fontWeight: '400',
                            }}
                        >Order Name: <span className="Titleinvo">{props?.orderInfo?.orderName || props?.orderInfo?.partnerOrderName}</span></Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="h6"
                            sx={{
                                fontSize: '16px',
                                color: '#B4B7B8',
                                fontWeight: '400',
                            }}
                        >Order Reference: <span className="Titleinvo">{props?.orderInfo?.orderRef || props?.orderInfo?.partnerOrderRef}</span></Typography>
                    </Grid>
                </Grid>
                <Box display="flex" justifyContent="space-between" mb={2}>


                </Box>



                {userPriority === PROFILE_TYPE.DISTRIBUTOR ? (
                    <Box mb={3}>
                        <Typography variant="subtitle1" gutterBottom className="CustomTl">
                            <b className="TitleInU">Partner Details</b>
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className="InTit">Partner Name: <span className="Titleinvo">{
                                    props?.orderInfo?.customer || 
                                    (props?.orderInfo?.vPartnerUser ? `${props?.orderInfo?.vPartnerUser?.name || ""} ${props?.orderInfo?.vPartnerUser?.lastName || ""}`.trim() : "") ||
                                    (props?.orderInfo?.partnerUser ? `${props?.orderInfo?.partnerUser?.name || ""} ${props?.orderInfo?.partnerUser?.lastName || ""}`.trim() : "")
                                }</span></Typography>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className="InTit">Partner Email: <span className="Titleinvo">{props?.orderInfo?.partnerId || ""}</span></Typography>
                            </Grid>
                        </Grid>
                    </Box>
                ) : (
                    <Box mb={3}>
                        <Typography variant="subtitle1" gutterBottom className="CustomTl">
                            <b className="TitleInU">Site / Device Details</b>
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className="InTit">Site / Device Name: <span className="Titleinvo">{props?.siteInfo?.name}</span></Typography>
                                <Typography className="InTit"> Address Line 1: <span className="Titleinvo">{props?.siteInfo?.address?.addressline1}</span></Typography>

                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Typography className="InTit">City: <span className="Titleinvo">{props?.siteInfo?.address?.city}</span></Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Typography className="InTit">State / Province: <span className="Titleinvo">{props?.siteInfo?.address?.state}</span></Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Typography className="InTit">Phone Number: <span className="Titleinvo">{props?.siteInfo?.contact?.phone?.number}</span></Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className="InTit">Email ID: <span className="Titleinvo">{props?.siteInfo?.contact?.email?.[0]?.id}</span></Typography>
                                <Typography className="InTit">Address Line 2: <span className="Titleinvo">{props?.siteInfo?.address?.addressline2}</span></Typography>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Typography className="InTit">Country: <span className="Titleinvo">{props?.siteInfo?.address?.country}</span></Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Typography className="InTit">Postal Code: <span className="Titleinvo">{props?.siteInfo?.address?.postalcode}</span></Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Typography className="InTit">Reference: <span className="Titleinvo"></span></Typography>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Box>
                )}

                <Box mb={3}>
                    <Typography variant="subtitle1" gutterBottom className="CustomTl">
                        <b className="TitleInU">Feature</b>
                    </Typography>
                    {props.selectedFeatureList?.map((item: any) => (
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className="InTit">Feature: &nbsp;
                                    <span className="Titleinvo">
                                        {item?.featureName || props.globalFeatureList?.find(
                                            (gitem: any) => gitem.license.key === item.licenseKey
                                        )?.license?.data?.name}
                                    </span>
                                </Typography>
                                <Typography className="InTit"> Quantity: <span className="Titleinvo">{item?.quantity}</span></Typography>

                                {/* <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className="InTit">Is trial: <span className="Titleinvo"></span></Typography>
                            </Grid>
                        </Grid> */}

                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <Typography className="InTit">License Type: {" "}
                                    <span className="Titleinvo">
                                        {item?.validity === 30
                                            ? '30 Days'
                                            : item?.validity === 365
                                                ? '1 Year'
                                                : item?.validity === 1095
                                                    ? '3 Years'
                                                    : item?.validity === 1825
                                                        ? '5 Years'
                                                        : ''}
                                    </span>
                                </Typography>
                            </Grid>
                        </Grid>
                    ))}
                </Box>


            </Paper>


            <Stack className="fStacky" direction="row" spacing={2} justifyContent="flex-end"
                sx={{
                    backgroundColor: '#03171F',
                    boxShadow: '-4px -4px 20px #91959621', borderTop: '1px solid #5A5F60', padding: 2,
                }}>
                {/* <Button onClick={() => props.setActiveStep(1)} variant="outlined" sx={{ color: '#0699CE', height: '41px', lineHeight: '41px', border: '0', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
            Previous
        </Button> */}
                <Button onClick={() => navigate("/orders")} variant="outlined" sx={{ marginRight: 'auto !important', color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                    Cancel
                </Button>
 
                <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    className="btnBlue"
                    sx={{
                        color: '#1F2F34', height: '41px', lineHeight: '41px',
                        borderColor: '#0B4A62',
                        borderRadius: '25px', fontSize: '14px', fontWidth: '500',
                    }}
                    onClick={() => navigate("/orders")}
                >
                    Ok
                </Button>
            </Stack>
        </>
    )
}

export default OrderCreateStep3Confirm